export const Image = (props) => (
  <img
    {...{
      ...props,
      src: props.path,
      alt: props.alt || 'Have no alt attr',
    }}
  />
);
